import React from 'react'
import { Checkbox } from '..'

interface Props<T> {
  onUpdate(arg: T): void
  items: T[]
  label: string
}

const CheckboxFiltering = <T,>({ onUpdate, items = [], label }: Props<T>) => {
  if (items.length === 0) return null
  return (
    <div>
      <div className='d-flex flex-column'>
        <h6 className='d-flex align-items-center pt-2 see-all__filter__checkbox-wrap__title mb-2'>{label}</h6>
        <div className='see-all__filter__checkbox-wrap d-flex flex-column flex-lg-row flex-wrap mb-3'>
          {items.map((op: T, x: number) => (
            <Checkbox
              key={x}
              label={typeof op === 'string' ? op : ''}
              containerClass='see-all__filter__checkbox-item mb-lg-1 mr-1'
              onClick={() => onUpdate(op)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default CheckboxFiltering
